import {
    InvoiceStatus,
    DealStatus,
    Company,
    Customer,
    Invoice,
    InvoiceTableRowStatus,
    Approval,
    Deal,
} from '@lendica/utils';

export const enum RowType {
    Invoice = 'invoice',
    Deal = 'deal',
}

export type DeepPartial<T> = T extends object
    ? {
          [P in keyof T]?: DeepPartial<T[P]>;
      }
    : T;

export interface InvoiceDetails {
    invoice: Invoice;
    customer: Customer | null;
    company: Company;
}

export interface InvoiceOrDealRow {
    id: string;
    invoice_number: string;
    funded_date?: string;
    vendor_name: string;
    amount?: number;
    paid?: number;
    type: RowType;
    status: InvoiceStatus | DealStatus;
}

export enum ActionType {
    Schedule = 'schedule',
    Edit = 'edit',
    View = 'view',
    Archive = 'archive',
}
export interface InvoiceTableRow {
    id: string;
    type: RowType;
    customer: string;
    status: InvoiceTableRowStatus;
    invoice_number: string;
    invoice_date: string;
    amount: string | number;
    due_date: string;
    funding_date: string;
}

export const NULL_VALUE_FALLBACK = `\u2014`;

export interface FundNowDataProps {
    approval: Approval | undefined;
    invoices: Invoice[] | undefined;
    deals: Deal[] | undefined;
}
